import { atom } from 'recoil';

export const CanBackToPlaceRelatedState = atom({
  key: 'CanBackToPlaceRelatedState',
  default: false,
});